// @ts-nocheck
import React, { FC, useState } from "react";
import {
  IonButton,
  IonCol,
  IonGrid,
  IonInput,
  IonLabel,
  IonRow,
  IonSpinner
} from "@ionic/react";
import cn from "classnames";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState, alertState } from "../../../atoms";
import { AlertModal } from "../../../components";
import { whichAuth as getAuth } from "../../../getAuth";
import AddressAutoComplete from '../../../components/AddressAutocomplete';

const Profile: FC = () => {
  const user = useRecoilValue(userState);
  const setUser = useSetRecoilState(userState);
  const setAlert = useSetRecoilState(alertState);

  const [firstName, setFirstName] = useState<string>(user?.firstName)
  const [lastName, setLastName] = useState<string>(user?.lastName)
  const [address, setAddress] = useState<string>(user?.address)
  const [contactNumber, setContactNumber] = useState<string>(user?.phone)
  const [disabledLeft, setDisabledLeft] = useState<boolean>(true)
  const [deletingAccount, setDeletingAccount] = useState<boolean>(false);
  
  const updateProfile = () => {
    const value = {
      name: `${firstName} ${lastName}`,
      address: address,
      phone: contactNumber,
    }
    getAuth().currentUser.getIdToken().then(token =>
      fetch(user._links.self.href, {
        method: 'PATCH',
        body: JSON.stringify(value),
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/merge-patch+json'
        }
      })
      .then(() => setUser({...user, ...value}))
      .catch(() => setAlert({
          isOpen:true,
          title:'Failed to save details',
          subTitle:'There was an error saving your details. Please try again or contact us.'
        }))
    )
  }
  
  const deleteAccount = () => {
    setDeletingAccount(true);
    getAuth().currentUser.getIdToken().then(token =>
      fetch(user._links.self.href, {
        method: 'DELETE',
        headers: {'Authorization': 'Bearer ' + token}
      })
      .then(() => setAlert({
        isOpen:true,
          title:'Your account is being deleted',
          buttonText:'Ok',
          showCancelButton:false,
          subTitle:<>
            <p>We have received you request and will be in touch as soon as your account has been deleted.</p>
            <p>Please remember to update your billing email address with your providers to ensure you receive your bills in future.</p>
            <p>If you have any questions, please contact us at <a target="_blank" href="mailto:hello@billsmoov.com.au">hello@billsmoov.com.au</a></p>
            </>
      }))
      .catch(() => setAlert({
          isOpen:true,
          title:'Delete failed',
          buttonText:'Ok',
          showCancelButton:false,
          subTitle:'Failed to send delete account request. Please try again or contact us.'
        }))
      .finally(() => setDeletingAccount(false))
    )
  }

  return (
    <IonGrid>
      <IonRow className="settings-row">
        <IonCol size="4" className="settings-col payment">
          <IonRow>
            <IonCol size="12" className="settings-col">
              <IonRow>
                <IonCol size="6" className="settings-col first">
                  <IonLabel className="settings-content-label">First Name</IonLabel>
                  <IonInput
                    className={cn('settings-content-input', { 'active': !disabledLeft })}
                    onIonChange={(event) => setFirstName(event.detail.value)}
                    value={firstName}
                    disabled={disabledLeft}
                    type="text"
                    required
                  />
                </IonCol>
                <IonCol size="6" className="settings-col last">
                  <IonLabel className="settings-content-label half-right">Last Name</IonLabel>
                  <IonInput
                    className={cn('settings-content-input', { 'active': !disabledLeft })}
                    onIonChange={(event) => setLastName(event.detail.value)}
                    value={lastName}
                    disabled={disabledLeft}
                    type="text"
                    required
                  />
                </IonCol>
                <IonCol size="12" className="settings-col">
                  <IonLabel className="settings-content-label half-right">Address</IonLabel>
                  <AddressAutoComplete
                    label='Address:'
                    disabled={disabledLeft}
                    initialAddress={user.address}
                    onAddressUpdate={updatedAddress => setAddress(updatedAddress)} />
                </IonCol>
                <IonCol size="12" className="settings-col">
                  <IonLabel className="settings-content-label">Email</IonLabel>
                  <IonInput
                    className={cn('settings-content-input', { 'active': !disabledLeft })}
                    value={user.email}
                    disabled
                    type="email"
                    required
                  />
                </IonCol>
                <IonCol size="12" className="settings-col">
                  <IonLabel className="settings-content-label">Contact Number</IonLabel>
                  <IonInput
                    className={cn('settings-content-input', { 'active': !disabledLeft })}
                    onIonChange={(event) => setContactNumber(event.detail.value)}
                    value={contactNumber}
                    disabled={disabledLeft}
                    autocomplete="tel"
                    type="email"
                    required
                  />
                </IonCol>
                {disabledLeft ? (
                  <>
                    <IonCol size="6" className="settings-col first">
                      <IonButton onClick={() => setDisabledLeft(false)} className="settings-content-button">
                        Edit
                      </IonButton>
                    </IonCol>
                    <IonCol size="6" className="settings-col last">
                      <IonButton className="settings-content-button cancel"
                        onClick={() => setAlert({
                          isOpen:true,
                          title:'Confirm account deletion',
                          buttonText:'Delete account',
                          showCancelButton:true,
                          onConfirm:deleteAccount,
                          subTitle:<>
                              <p>Please confirm that you wish to delete your account.</p>
                              <p>
                                If you have changed your provider billing email address to your Billsmoov email, you will need to make the necessary updates.
                                Once your account is deleted, you will no longer receive emails forwarded to your Billsmoov email address.
                              </p>
                            </>
                        })}>
                        {deletingAccount && <IonSpinner name="dots" />} Delete account
                      </IonButton>
                    </IonCol>
                  </>
                ) : (
                  <>
                    <IonCol size="6" className="settings-col first">
                      <IonButton onClick={() => {
                        setDisabledLeft(true)
                        updateProfile()
                      }} className="settings-content-button">
                        Save
                      </IonButton>
                    </IonCol>
                    <IonCol size="6" className="settings-col last">
                      <IonButton onClick={() => setDisabledLeft(true)} className="settings-content-button cancel">
                        Cancel
                      </IonButton>
                    </IonCol>
                  </>)}
              </IonRow>
            </IonCol>
          </IonRow>
        </IonCol>
      </IonRow>
    </IonGrid>
  )
}

export default Profile
